import { baoCaoTienBoApi } from '../../../api/baoCaoTienBoApi';
import { IBaoCaoTienBoSelectRequest } from '../../../models/request/bao-cao-tien-do/BaoCaoTienBoSelectRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eTheoDoiRCActionTypeIds, ITheoDoiRCActionTypes } from './../../action-types/theo-doi-rc/ITheoDoiRCActionTypes';
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"


export function* theoDoiRCSaga(): any {
    yield takeLatest(eTheoDoiRCActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eTheoDoiRCActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ITheoDoiRCActionTypes): any {
    const res: IBaseResponeModel = yield call(baoCaoTienBoApi.GetConfirmVm, action.payload as IBaoCaoTienBoSelectRequest)
    if (res.is_success) {
        yield put(actions.theoDoiRCActions.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.theoDoiRCActions.LOAD_ERROR(res.message ??"Error"))
    }
}

function* deleteWorker(action: ITheoDoiRCActionTypes): any {
    const res: IBaseResponeModel = yield call(baoCaoTienBoApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(actions.theoDoiRCActions.DELETE_SUCCESS(res.data))
    } else {
        yield put(actions.theoDoiRCActions.DELETE_ERROR(res.message ??"Error"))
    }
}
